import { render, staticRenderFns } from "./TeacherWorkList.vue?vue&type=template&id=3f4bb224&scoped=true"
import script from "./TeacherWorkList.vue?vue&type=script&lang=js"
export * from "./TeacherWorkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4bb224",
  null
  
)

export default component.exports